var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsActionsFullscreen = function SvgArrowsActionsFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v7l2.781-2.781 3 3L10.22 8.78l-3-3L10 3H3Zm11 0 2.781 2.781-3 3 1.438 1.438 3-3L21 10V3h-7ZM8.781 13.781l-3 3L3 14v7h7l-2.781-2.781 3-3L8.78 13.78Zm6.438 0L13.78 15.22l3 3L14 21h7v-7l-2.781 2.781-3-3Z"
  })));
};
export default SvgArrowsActionsFullscreen;